export const getPositionStyles = (bodyRect: DOMRect, inputRect: DOMRect, popperRect: DOMRect) => {
  let top = inputRect.bottom - bodyRect.top
  if (top + popperRect.height > document.body.clientHeight) {
    top = inputRect.top - popperRect.height - bodyRect.top
  }
  if (inputRect.left + popperRect.width > document.body.clientWidth) {
    return { left: inputRect.right - popperRect.width, top, opacity: 1 }
  } else {
    return { left: inputRect.left, top, opacity: 1 }
  }
}
